import request from '@/utils/request'

let Fault_inquiryApi = {

  /*故障查询列表*/
  list(data) {
    return request._post('/shop/plus.fault_inquiry.Index/index', data);
},
/*添加故障查询*/
add(data) {
    return request._post('/shop/plus.fault_inquiry.Index/add', data);
},
/*修改故障查询*/
edit(data) {
    return request._post('/shop/plus.fault_inquiry.Index/edit', data);
},
/*删除故障查询*/
del(data) {
    return request._post('/shop/plus.fault_inquiry.Index/del', data);
},
/*故障查询详情*/
detail(data) {
  return request._post('/shop/plus.fault_inquiry.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.fault_inquiry.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.fault_inquiry.Setting/getSetting', data, errorback);
    },
}
export default Fault_inquiryApi;



// WEBPACK FOOTER //
// ./src/api/fault_inquiry.js